import { isPlatformBrowser } from '@angular/common';
import {
  Component,
  OnInit,
  Input,
  Output,
  EventEmitter,
  ElementRef,
  ViewChild,
  AfterViewInit,
  OnDestroy,
  Inject,
  InjectionToken,
  PLATFORM_ID,
} from '@angular/core';
import { Button, Image } from '../../models';

@Component({
    selector: 'app-header',
    templateUrl: './header.component.html',
    standalone: false
})
export class HeaderComponent implements AfterViewInit, OnDestroy {
  @Input() imageUrl: string = '';
  @Input() title: string = '';
  @Input() subtitle: string = '';
  @Input() text: string = '';
  @Input() image?: Image;
  @Input() button?: Button;
  @Input() transparentNav: boolean = false;
  @Input() backgroundImage: boolean = false;
  @Input() isSlider: boolean = false;

  @ViewChild('headerElMain') elMain!: ElementRef;

  constructor(@Inject(PLATFORM_ID) private platformId: InjectionToken<Object>) {}

  getBackground(image: string | undefined) {
    if (!image) {
      return '';
    }
    return `url('${image}')`;
  }

  ngAfterViewInit(): void {
    if (isPlatformBrowser(this.platformId)) {
      const height = this.elMain.nativeElement.offsetHeight;
      document.documentElement.style.setProperty('--header-height', height + 'px');
    }
  }

  ngOnDestroy(): void {
    if (isPlatformBrowser(this.platformId)) {
      document.documentElement.style.removeProperty('--header-height');
    }
  }
}
